// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__11FxZ","label":"Section_label__ZIH1t","contentWrap":"Section_contentWrap__YkcHS","footer":"Section_footer__1alx9","footerInner":"Section_footerInner__2nrCT"};